import "./App.css";
import logos from "./assets/TMC+logo.png";
import { useEffect, useRef, useState } from "react";
import SalahTimeTable from "./Salah";
import ID from "./assets/id.png";

import Lottie from "react-lottie";
import animationData from "./assets/animation.json";
import animationData2 from "./assets/animation2.json";
import animationData3 from "./assets/animation3.json";
import animationData4 from "./assets/animation4.json";
import animationData5 from "./assets/animation5.json";
import animationData6 from "./assets/animation6.json";
import animationData7 from "./assets/animation7.json";
import animationData8 from "./assets/animation8.json";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebook,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

import Library from "./assets/library.MOV";
import MSC from "./assets/msc.MOV";

// import sanityClient from "./client";

import createClient from "./Client";
import imageUrlBuilder from "@sanity/image-url";

const builder = imageUrlBuilder(createClient);

function urlFor(source) {
  return builder.image(source);
}

// import data from sanity post
const query = `*[_type == "salahtimes"]{
  dhuhr,
  asr,
  maghrib,
  isha
}`;

const query2 = `*[_type == "upcomingEvents"]{
  title,
  date,
  image,
  description
}`;

const query3 = `*[_type == "eboard"]{
  name,
  position,
  image,
  intro
}`;

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
const defaultOptions2 = {
  loop: true,
  autoplay: true,
  animationData: animationData2,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const defaultOptions3 = {
  loop: true,
  autoplay: true,
  animationData: animationData3,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const defaultOptions4 = {
  loop: true,
  autoplay: true,
  animationData: animationData4,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const defaultOptions5 = {
  loop: true,
  autoplay: true,
  animationData: animationData5,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const defaultOptions6 = {
  loop: true,
  autoplay: true,
  animationData: animationData6,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const defaultOptions7 = {
  loop: true,
  autoplay: true,
  animationData: animationData7,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const defaultOptions8 = {
  loop: true,
  autoplay: true,
  animationData: animationData8,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

// App component
function App() {
  const eventsRef = useRef(null);
  const eboardRef = useRef(null);
  const [salahTimes, setSalahTimes] = useState(null);
  const [upcomingEvents, setUpcomingEvents] = useState(null);
  const [eboard, setEboard] = useState(null);

  useEffect(() => {
    createClient
      .fetch(query)
      .then((data) => setSalahTimes(data))
      .catch(console.error);

    createClient
      .fetch(query2)
      .then((data) => setUpcomingEvents(data))
      .catch(console.error);

    createClient
      .fetch(query3)
      .then((data) => setEboard(data))
      .catch(console.error);
  }, []);

  // console.log("post data: ", salahTimes);
  // console.log("upcoming events: ", upcomingEvents);
  return (
    <div className="App">
      <NavBar eventsRef={eventsRef} eboardRef={eboardRef} />{" "}
      {/* Pass the ref to NavBar */}
      <div
        style={{
          height: 250,
          width: 300,
          display: "flex",
          alignContent: "center",
          alignItems: "center",
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: 20,
        }}
      >
        <Lottie options={defaultOptions6} />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <PrayerLocation />
      </div>
      {salahTimes && <SalahTimeTable salahTimes={salahTimes} />}
      <div ref={eventsRef}>
        {/* Assign the ref to the section */}
        <div
          style={{
            height: 250,
            width: 300,
            display: "flex",
            alignContent: "center",
            alignItems: "center",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: -50,
          }}
        >
          <Lottie options={defaultOptions8} />
        </div>
        {upcomingEvents && <Events upcomingEvents={upcomingEvents} />}
      </div>
      <div ref={eboardRef}>
        {/* Assign the ref to the section */}
        <div
          style={{
            height: 250,
            width: 300,
            display: "flex",
            alignContent: "center",
            alignItems: "center",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: -50,
          }}
        >
          <Lottie options={defaultOptions3} />
        </div>
        {eboard && <Eboard eboard={eboard} />}
      </div>
      <div style={{ marginTop: 200 }}>
        <Footer />
      </div>
    </div>
  );
}
function PrayerLocation() {
  const [locationSelected, setLocationSelected] = useState(null);
  const [videoKey, setVideoKey] = useState(0);
  const locationRef = useRef(null);

  const setLocation = (location) => {
    if (locationSelected !== location) {
      setVideoKey((prevKey) => prevKey + 1);
      setLocationSelected(location);
    }
    window.scrollTo({
      top: locationRef.current.offsetTop,
      behavior: "smooth",
    });
  };

  const buttonStyle = {
    backgroundColor: "black",
    color: "white",
    padding: "10px 15px",
    borderRadius: "5px",
    marginTop: "5px",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };

  const videoStyle = {
    borderRadius: 20,
    width: "420px",
    height: "440px",
    autoPlay: true,
    controls: true,
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#FFFFF0",
        // padding: "20px",
        margin: "20px",
      }}
    >
      <h2 style={{ color: "black" }}>Where do I pray on campus?</h2>
      <div ref={locationRef}>
        {locationSelected && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <video
              key={videoKey} // Add the key here
              width="420"
              height="440"
              controls
              style={{ borderRadius: 20 }}
              autoPlay
            >
              <source
                src={locationSelected === "MSC" ? MSC : Library}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
            <button
              style={buttonStyle}
              onClick={() => setLocationSelected(null)}
            >
              Close
            </button>
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
          backgroundColor: "#FFFFF0",
          padding: "20px",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "10px",
            fontFamily: "'Dosis', sans-serif",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "20px",
              marginBottom: "0px",
              fontFamily: "'Dosis', sans-serif",
              fontSize: "0.8rem",
              width: "100%",
            }}
          >
            <div style={{ width: "100%", color: "black" }}>
              <p style={{ textAlign: "center" }}>
                Prophet Muhammad ﷺ said: “The (whole) earth has been made a
                mosque (or a place of prayer) and a means of purification for
                me, so wherever a man of my ummah may be when the time for
                prayer comes, let him pray.”
                <br />
                (Sahih al-Bukhari 438)
              </p>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h3
            style={{
              fontFamily: "'Dosis', sans-serif",
              fontSize: "1rem",
              textAlign: "center",
              marginBotton: "0px",
              color: "black",
            }}
          >
            We have two designated spots of prayer on-campus
          </h3>
          <button style={buttonStyle} onClick={() => setLocation("MSC")}>
            Serenity Room @ MSC
            <span style={{ marginLeft: 10, fontSize: 7 }}>
              Click to see directions
            </span>
          </button>
          <button style={buttonStyle} onClick={() => setLocation("Library")}>
            The Library Basement
            <span style={{ marginLeft: 10, fontSize: 7 }}>
              Click to see directions
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

function Eboard({ eboard }) {
  const [selectedMember, setSelectedMember] = useState(null);
  const detailsRef = useRef(null);

  const closeDetails = () => {
    setSelectedMember(null);
  };

  // sort eboard by position ... President, Vice-President(external), Vice-President(internal), Secretary, Treasurer, Jummuah Coordinator, Social Media Coordinator, Community Outreach Coordinator, Event Coordinator, Dawah Coordinator, General Body Member
  // eboard now looks like this: [{name:"Jane, position:"President"}, {name:"John", position:"Vice-President(external)"}, ...]

  const positionOrder = [
    "President",
    "Vice-President (external)",
    "Vice-President (internal)",
    "Secretary",
    "Treasurer",
    "Jummuah Coordinator",
    "Social Media Coordinator",
    "Community Outreach Coordinator",
    "Event Coordinator",
    "Dawah Coordinator",
    "Chief of Operations",
    "Board Advisor",
  ];

  // Convert positionOrder to lowercase for case-insensitive comparison
  const positionOrderLower = positionOrder.map((pos) => pos.toLowerCase());

  // Sort eboard based on positionOrder, case-insensitively
  eboard.sort((a, b) => {
    // console.log("a: ", a);
    // console.log("b: ", b);
    let positionA = positionOrderLower.indexOf(a.position.toLowerCase());
    let positionB = positionOrderLower.indexOf(b.position.toLowerCase());

    // If the position is not found in positionOrderLower, it will go to the end of the list
    positionA = positionA === -1 ? positionOrderLower.length : positionA;
    positionB = positionB === -1 ? positionOrderLower.length : positionB;

    return positionA - positionB;
  });

  // console.log("sorted eboard: ", eboard);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "20px",
        fontFamily: "'Dosis', sans-serif",
        fontSize: "1.5rem",
      }}
    >
      <h2>Executive Board</h2>
      <div ref={detailsRef}>
        {selectedMember && (
          <EboardMemberDetails member={selectedMember} close={closeDetails} />
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
          justifyContent: "center",
          maxWidth: "900px",
          margin: "auto",
        }}
      >
        {eboard.map((member, index) => (
          <div style={{ flex: "1 0 280px", maxWidth: "calc(100%/3 - 20px)" }}>
            {" "}
            {/* Ensures each item takes at least 280px width, and max three items per row */}
            <EboardMember
              key={index}
              member={member}
              selectedMember={selectedMember}
              setSelectedMember={setSelectedMember}
              eventRef={detailsRef}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

function EboardMemberDetails({ member, close }) {
  // this isnt a modal, just a div that appears when a member is clicked
  return (
    // display: flex, left side is image, name and position, right side is intro
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "10px",
        maxWidth: "550px", // Set the maximum width here
        minWidth: "300px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          // alignItems: "center",
          justifyContent: "center",
          fontFamily: "'Dosis', sans-serif",
          position: "relative",
          backgroundColor: "#006948",
          width: "100%", // Use 100% of parent's width
          border: "1px solid black",
        }}
      >
        <div style={{ height: "85%", display: "flex" }}>
          <div
            style={{
              width: "30%",
              top: 0,
              left: 0,
              alignItems: "flex-start",
            }}
          >
            {/* start the image from the top left corner 0 margin */}
            <img
              src={urlFor(member.image).url()}
              alt={member.name}
              style={{
                borderRadius: "5px",

                marginLeft: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>
          <div style={{ width: "70%", marginLeft: 10 }}>
            {/* image from assets, id.png */}
            <img
              src={ID}
              alt="ID"
              style={{
                width: 250,
                height: 100,
                top: 0,
                left: 0,
                marginBottom: -20,
              }}
            />
            <p
              style={{
                color: "#D1DD1D",
                fontSize: 20,
                fontFamily: "Lato",
                marginLeft: 4,
              }}
            >
              {member.position}
            </p>

            <p
              style={{
                color: "white",
                fontSize: 20,
                fontWeight: "bold",
                fontFamily: "Lato",
                margin: 5,
              }}
            >
              64001300860045672
              <br />
              205-000-92012344
            </p>

            {/* <p style={{ fontFamily: "'Dosis', sans-serif", fontSize: "0.7rem" }}>
            {member.intro}
          </p> */}
          </div>
        </div>
        <div
          style={{
            height: "15%",
            width: "100%",
            display: "flex",
            // border: "1px solid black",
            borderTop: "1px solid black",
            backgroundColor: "white",
            color: "#006948",
            flexDirection: "flex-start",
            alignItems: "center",

            fontSize: "1rem",
          }}
        >
          {/* make it all uppercase */}
          <h3
            style={{
              textAlign: "left",
              marginLeft: 20,
              textTransform: "uppercase",
              fontFamily: "Sans-serif",
              fontSize: 20,
            }}
          >
            {member.name}
          </h3>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "'Dosis', sans-serif",
          position: "relative",
          backgroundColor: "white",
          width: "100%", // Use 100% of parent's width
          maxHeight: "450px",
          minWidth: "300px",
          border: "1px solid black",
          marginTop: 20,
        }}
      >
        <div
          style={{
            height: "85%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <p
            style={{
              fontFamily: "'Dosis', sans-serif",
              fontSize: "0.8rem",
              paddingLeft: 20,
              paddingRight: 20,
              textTransform: "lowercase",
              overflow: "hidden",
              top: 10,
              position: "abosolute",
            }}
          >
            {member.intro}
          </p>
        </div>

        <p
          style={{
            fontFamily: "monospace",
            fontStyle: "italic",
            fontWeight: "bold",
            fontSize: 20,
            textAlign: "center",
            marginBottom: -10,
            marginTop: -10,
          }}
        >
          USF·BULL·BUCK$
        </p>
        <p
          style={{ fontFamily: "monospace", fontSize: 10, textAlign: "center" }}
        >
          Sign up at www.usf.edu/Bullbucks
        </p>
        <div
          style={{
            backgroundColor: "black",
            width: "100%",
            minHeight: "30px",
            padding: "1px",
          }}
        >
          &nbsp; {/* Non-breaking space to ensure visibility */}
        </div>
        <p
          style={{ fontFamily: "monospace", fontSize: 10, textAlign: "center" }}
        >
          The cardholder is responsible for any and all losses associated with
          this card.
        </p>
      </div>
      <button
        style={{
          backgroundColor: "black",
          color: "white",
          padding: "10px 15px",
          borderRadius: "5px",
          marginTop: "20px",
          cursor: "pointer",
        }}
        onClick={close}
      >
        Close
      </button>
    </div>
  );
}

function EboardMember({ member, selectedMember, setSelectedMember, eventRef }) {
  const [introVisible, setIntroVisible] = useState(false);

  // Make sure the image is centered and maintains aspect ratio.
  const imageStyle = {
    width: "80px", // fixed width or use percentage
    height: "80px", // fixed height for maintaining aspect ratio
    objectFit: "cover", // this will make sure to cover the area without stretching the image
    borderRadius: "50%",
    margin: "0 auto", // this ensures that the image is centered
  };

  // Ensuring consistent spacing for name and position.
  const textStyle = {
    margin: "10px 0", // consistent top and bottom margin
    minHeight: "40px", // this ensures that the text area has a minimum height
  };

  const MemberSelected = () => {
    setSelectedMember(member);
    window.scrollTo({
      top: eventRef.current.offsetTop,
      behavior: "smooth",
    });
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        color: "black",
        fontSize: "1rem",
        textAlign: "center",
      }}
      onClick={() => MemberSelected()}
    >
      <img
        src={urlFor(member.image).url()}
        alt={member.name}
        style={imageStyle}
      />
      <p style={textStyle}>{member.position}</p>
      <p style={{ fontSize: "0.5rem", marginTop: -10 }}>Click for details</p>
    </div>
  );
}

function Events({ upcomingEvents }) {
  const currentDate = new Date();

  const upcoming = upcomingEvents.filter(
    (event) => new Date(event.date) > currentDate
  );
  const past = upcomingEvents.filter(
    (event) => new Date(event.date) <= currentDate
  );

  const renderEventList = (events, title) => (
    <>
      <h2>{title}</h2>
      {events.map((event, index) => (
        <Event key={index} event={event} />
      ))}
    </>
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "20px",
        fontFamily: "'Dosis', sans-serif",
        fontSize: "1.5rem",
      }}
    >
      {upcoming.length > 0 && renderEventList(upcoming, "Upcoming Events")}
      {past.length > 0 && renderEventList(past, "Past Events")}
    </div>
  );
}

function Event({ event }) {
  const createGoogleCalendarUrl = (event) => {
    const title = encodeURIComponent(event.title);
    const description = encodeURIComponent(event.description);
    const startDate = formatGoogleDate(new Date(event.date));
    const endDate = formatGoogleDate(new Date(event.date)); // You might want to adjust this if your event has a specific end time

    const baseUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE`;
    return `${baseUrl}&text=${title}&dates=${startDate}/${endDate}&details=${description}`;
  };

  // Function to format dates for Google Calendar URL
  const formatGoogleDate = (date) => {
    const formattedDate = date.toISOString().replace(/-|:|\.\d\d\d/g, "");
    return formattedDate;
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        margin: "10px",
        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
        borderRadius: "10px",
        backgroundColor: "black",
        maxWidth: "300px",
        textAlign: "center",
        color: "white",
      }}
    >
      <h3>{event.title}</h3>
      {event.description && <h5>{event.description}</h5>}
      <p>{new Date(event.date).toDateString()}</p>
      <img
        src={urlFor(event.image).url()}
        alt={event.title}
        style={{ width: "100%", height: "auto", borderRadius: "5px" }}
      />
      {/* show mark my calender only if date is in the future */}
      {new Date(event.date) > new Date() && (
        <a
          href={createGoogleCalendarUrl(event)}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            color: "black",
            backgroundColor: "white",
            padding: "10px 15px",
            borderRadius: "5px",
            marginTop: "10px",
          }}
        >
          Mark My Calendar
        </a>
      )}
    </div>
  );
}

function NavBar({ eventsRef, eboardRef }) {
  const scrollToSection = (sectionRef) => {
    window.scrollTo({
      top: sectionRef.current.offsetTop,
      behavior: "smooth",
    });
  };

  const navBarStyle = {
    backgroundColor: "black",
    padding: "10px 0",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    width: "100%",
  };

  // Style for the inner nav bar container
  const navBarStyle2 = {
    backgroundColor: "black", // Blue color
    padding: "10px 0",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    width: "100%",
  };

  // Link style with updated color
  const linkStyle = {
    margin: "0 15px",
    textDecoration: "none",
    color: "white", // White color for better contrast on blue background
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
    backgroundColor: "black",
    padding: "10px 15px",
    borderRadius: "5px",
    fontSize: "0.7rem",
    fontFamily: "'Dosis', sans-serif",
  };

  console.log(
    "Assalamualaikum, nothing to check here. Send salwaat to the Prophet (saw) and his family."
  );

  return (
    <div style={navBarStyle}>
      <img src={logos} alt="TMC Logo" className="App-logo" />
      <div style={navBarStyle2}>
        <a href="/" style={linkStyle}>
          <h3>Salah</h3>
        </a>
        <div style={linkStyle} onClick={() => scrollToSection(eventsRef)}>
          <h3>Events</h3>
        </div>
        <div style={linkStyle} onClick={() => scrollToSection(eboardRef)}>
          <h3>Eboard</h3>
        </div>
      </div>
    </div>
  );
}

function Footer() {
  return (
    <footer
      style={{
        position: "fixed",
        bottom: "0",
        width: "100%",
        backgroundColor: "#333",
        color: "white",
        textAlign: "center",
        padding: "10px 0",
        minHeight: "50px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <a
        href="https://www.instagram.com/tmcusf"
        style={{ color: "white", margin: "0 10px" }}
      >
        <FontAwesomeIcon icon={faInstagram} size="2x" />
      </a>
      <a
        href="https://www.facebook.com/themuslimconnection"
        style={{ color: "white", margin: "0 10px" }}
      >
        <FontAwesomeIcon icon={faFacebook} size="2x" />
      </a>
      <a
        href="https://www.youtube.com/@MuslimConnection"
        style={{ color: "white", margin: "0 10px" }}
      >
        <FontAwesomeIcon icon={faYoutube} size="2x" />
      </a>
    </footer>
  );
}

export default App;
